import React from 'react';
import SalvPage from '../common/SalvPage';
import BridgeApiConfiguration from './BridgeApiConfiguration';
import BridgeRecipientConfigurations from './bridge-recipient-mapping/BridgeRecipientConfigurations';
import { useQueryBridgeApiConfiguration } from './bridgeActions';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../organisation/feature/helper';
import { useMe } from '../organisation/useMe';

const BridgeSettings = () => {
  const { features } = useMe();

  const { data: bridgeApiConfiguration, isFetched } = useQueryBridgeApiConfiguration();

  return (
    <SalvPage title='Bridge Settings' isLoading={!isFetched}>
      <BridgeApiConfiguration />

      {bridgeApiConfiguration && isFeatureEnabled(ORGANISATION_FEATURE.BRIDGE_MESSAGING_OUTGOING, features) && (
        <BridgeRecipientConfigurations />
      )}
    </SalvPage>
  );
};

export default BridgeSettings;
